module.exports = __webpack_public_path__ + "media/images/steps/svg/172-deal-1-a29a26b3bbc8301f723a282be18913cb.svg";